import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Layout } from "antd";
import { EnhancedProps } from 'src/pages/student/models/props';
import SVGComponent from 'src/components/common/SVGComponent';

const { Content } = Layout;
const SmokeImagePath = require('src/assets/qci/sprites/starPods/smoke.svg');

export interface Landing2Props extends EnhancedProps {
}

class Landing2 extends React.Component<Landing2Props> {
    constructor(props: Landing2Props) {
        super(props);
        bindAllOfThis(this, Landing2.prototype);
    }

    onNext() {
        this.props.onNext();
    }

    componentDidMount() {
        document.body.classList.add("landing");

        setTimeout(() => {
            this.onNext();
        }, 4000);
    }

    componentWillUnmount(): void {
        document.body.classList.remove("landing");
    }

    render() {
        let planetCode: string = this.props.currentPlanet.name.toLowerCase() as string;

        let terrainClassName = `planet-terrain planet-terrain-${planetCode}`;
        let podClassName = `star-pod star-pod-landing star-pod-${planetCode}-landing`;
        let podClassLanded = `star-pod star-pod-landed star-pod-${planetCode}-landed`;

        return <Content style={{ height: '100vh', overflow: 'hidden' }}>
            <div className="star-pod-animated">
                <div className={podClassName} />
                <div className={podClassLanded} />
                <SVGComponent
                    path={SmokeImagePath}
                    id="smoke"
                />
            </div>
            <div className={terrainClassName} />
        </Content>;
    }
}

export default Landing2;



// WEBPACK FOOTER //
// ./src/pages/student/scenes/Landing2.tsx